import { appLog, flushAppLogs } from './appLog';

/**
 * Catches a launch that ends on an empty screen (Sam, 2026-11-01: a black screen on 2 of 4 cold opens, with nothing in the
 * logs to say why). From the moment the launch splash leaves, the page is checked every half second: if it still shows
 * nothing at 2 s, `app.blank` records what was there (route, header, the main area's words and pictures, a map canvas,
 * whether the page is visible and online) and the logs go up at once, so they survive you closing the app. When words
 * do appear, `app.first_content` says how long it took. Once per app run.
 */
const BLANK_AT_MS = 2000;
const GIVE_UP_MS = 30000;
const STEP_MS = 500;
let started = false;

function snapshot() {
  const main = document.querySelector('#app-layer main');
  const text = (main?.innerText || '').replace(/\s+/g, ' ').trim();
  const imgs = main ? [...main.querySelectorAll('img')] : [];
  const rect = main?.getBoundingClientRect();
  return {
    route: window.location.pathname,
    textChars: text.length,
    text: text.slice(0, 80),
    imgs: imgs.length,
    imgsLoaded: imgs.filter((i) => i.complete && i.naturalWidth > 0).length,
    canvas: Boolean(document.querySelector('canvas')),
    header: Boolean(document.querySelector('#app-layer header')),
    appLayer: Boolean(document.getElementById('app-layer')),
    mainH: rect ? Math.round(rect.height) : null,
    visible: document.visibilityState,
    online: navigator.onLine,
  };
}

const hasContent = (s) => s.textChars >= 20 || s.imgsLoaded > 0;

/** @param {'launch' | 'reload'} via the splash finished, or a quick reload that shows no splash */
export function watchForBlank(via) {
  if (started || typeof document === 'undefined') return;
  started = true;
  const t0 = performance.now();
  let reported = false;
  const tick = () => {
    const ms = Math.round(performance.now() - t0);
    const s = snapshot();
    if (hasContent(s)) {
      // only worth a line when it was slow (a blank was reported, or it took over a second)
      if (reported || ms > 1000) {
        appLog('info', 'app.first_content', { via, ms, route: s.route, wasBlank: reported });
        if (reported) void flushAppLogs('blank');
      }
      return;
    }
    if (!reported && ms >= BLANK_AT_MS && s.visible === 'visible') {
      reported = true;
      appLog('warn', 'app.blank', { via, ms, ...s });
      void flushAppLogs('blank');
    }
    if (ms < GIVE_UP_MS) setTimeout(tick, STEP_MS);
    else if (reported) appLog('warn', 'app.blank_still', { via, ms, ...s });
  };
  setTimeout(tick, STEP_MS);
}
